import { Link, useNavigate } from "react-router-dom"
import "./css/Forms.css"
import { useContext, useEffect, useState, useRef } from "react"
import { DashboardState } from "./Dashboard"
import CustomisedForm from "../components/CustomisedForm"
import axios from "axios"
import api from "../config/backend"
import { SpinnerCircular } from "spinners-react"
import { Button, Container, Grid, IconButton, Tooltip } from "@mui/material"
import { Scrollbar } from "react-scrollbars-custom"
import { ContentCopy, ControlPointDuplicateRounded } from "@mui/icons-material"
import { TiTickOutline } from "react-icons/ti"

const Forms = () => {
    const [formdata, setFormdata] = useState(undefined)
    const [submissions, setSubmissions] = useState([])

    const { state, actions } = useContext(DashboardState)

    const token = localStorage.getItem("_crm__token")

    const domain = window.location.host
    const protocol = window.location.protocol

    const navigate = useNavigate()

    const code = `
    <div id="_9lih-hash__container" data-hash="${formdata ? formdata.hash : undefined}">
        <div id="_0wfk-form__container"></div>
    </div>
    `

    const scriptcode = `
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800;900&display=swap"
        rel="stylesheet">
    <script defer="defer" src="https://crmplugin.netlify.app/static/js/main.js"></script>
    <link href="https://crmplugin.netlify.app/static/css/main.css" rel="stylesheet">
        `
    // <script defer="defer" src="https://crmplugin.netlify.app/static/js/main.js"></script>
    // <link href="https://crmplugin.netlify.app/static/css/main.css" rel="stylesheet">

    // <script defer="defer" src="https://crm-stage-plugin.netlify.app/static/js/main.js"></script>
    // <link href="https://crm-stage-plugin.netlify.app/static/css/main.css" rel="stylesheet"></link>

    const fetchForm = async () => {
        const { data, status } = await axios.post(`${api}/Form/fetch-details`, { token })

        if (data.success) {
            setFormdata(data.form)
        } else {
            console.log({ data })
        }
    }

    const fetchSubmissions = async () => {
        const { data, status } = await axios.post(`${api}/Form/fetch-submissions`, { token })

        if (data.success) {
            setSubmissions(data.submissions)
        } else {
            console.log({ data })
        }
    }

    useEffect(() => {
        fetchForm()
        fetchSubmissions()
    }, [])
    const textAreaRef = useRef(null)
    const [copied, setCopied] = useState(false)
    const [copiedd, setCopiedd] = useState(false)
    const [anothercopy, setAnotherCopy] = useState(false)
    const copyToClipboard = () => {
        const link = `${protocol}//${domain}/crm/share/${formdata ? formdata.hash : ''}`
        const tempInput = document.createElement('input')
        tempInput.value = link
        document.body.appendChild(tempInput)
        tempInput.select()
        document.execCommand('copy')
        document.body.removeChild(tempInput)
        setCopied(true)
        setTimeout(() => {
            setCopied(false)
        }, 3000)
    }
    const copyData = () => {
        const tempInput = document.createElement('textarea')
        tempInput.value = code
        document.body.appendChild(tempInput)
        tempInput.select()
        document.execCommand('copy')
        document.body.removeChild(tempInput)
        setCopiedd(true)
        setTimeout(() => {
            setCopiedd(false)
        }, 3000)
    }
    const copyCode = () => {
        const tempInput = document.createElement('textarea')
        tempInput.value = scriptcode
        document.body.appendChild(tempInput)
        tempInput.select()
        document.execCommand('copy')
        document.body.removeChild(tempInput)
        setAnotherCopy(true)
        setTimeout(() => {
            setAnotherCopy(false)
        }, 3000)
    }

    const publicform = `${protocol}//${domain}/crm/share/${formdata ? formdata.hash : undefined}`

    return (
        <>
            <div>
                {/* <Container> */}
                <div className="app-page-form">
                <div className="app-page-form__header">
                    <div className="app-page-form__header--title">
                        <h4>Form</h4>
                        <span>Last modified on: {formdata ? new Date(formdata.modifiedon).toDateString() : undefined}</span>
                    </div>
                    <div className="app-page-form__header--actions">
                        <Button className="app-btn-text" onClick={() => { navigate("/view-submissions") }}>View submissions</Button>
                        <Button variant="contained" className="app-btn-contained app-btn-primary" onClick={() => { navigate("/customise-form") }}>Customise Form</Button>
                    </div>
                </div>
                <Grid container>
                    <Grid item md={6.5} lg={6.5}>
                        <div className="app-page-form__left">
                            <div>
                                <div className="app-page-form__analytics">
                                    <ul>
                                        <li>
                                            <p>Views</p>
                                            <h3>{formdata ? formdata.views : undefined}</h3>
                                        </li>
                                        <li>
                                            <p>Submits</p>
                                            <h3>{submissions.length}</h3>
                                        </li>
                                        <li>
                                            <p>Conversion Rate</p>
                                            <h3>
                                                {formdata && formdata.views !== 0
                                                    ? `${((submissions.length / formdata.views) * 100).toFixed(0)}%`
                                                    : "0%"}
                                            </h3>
                                        </li>
                                    </ul>
                                </div>
                                <div className="_5epx">
                                    <div className="app-page-form__share">
                                        <h4 className="app-page-form--subtitle">Share</h4>
                                        <div className="app-page-form__share--wrapper">
                                            <div className="app-page-form__share--link">
                                                <a
                                                    className="rubylike-site"
                                                    href={publicform}
                                                    target="_blank"
                                                    ref={textAreaRef}
                                                >
                                                    {publicform}
                                                </a>
                                            </div>
                                            <Tooltip title="Copy Link">
                                                <IconButton onClick={copyToClipboard}>
                                                    {copied ? <TiTickOutline /> : <ContentCopy />}
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <div className="app-page-form__embed">
                                        <h4 className="app-page-form--subtitle">Embed in website</h4>
                                        <div className="app-page-form__embed--code" style={{ marginBottom: "20px" }}>
                                            <Tooltip title="Copy code">
                                                <IconButton onClick={copyCode}>
                                                    {anothercopy ? <TiTickOutline /> : <ContentCopy />}
                                                </IconButton>
                                            </Tooltip>
                                            <div className="last-code-scroll" style={{ overflowX: "scroll" }} >
                                                <div className="_2zmx" style={{ width: "900px" }}>
                                                    <code>{scriptcode}</code>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="app-page-form__embed--code">
                                            <Tooltip title="Copy code">
                                                <IconButton onClick={copyData}>
                                                    {copiedd ? <TiTickOutline /> : <ContentCopy />}
                                                </IconButton>
                                            </Tooltip>
                                            <div className="last-code-scroll" style={{ overflowX: "scroll" }} >

                                                <div className="_2zmx" style={{ width: "700px" }}>
                                                    <code>{code}</code>
                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </Grid>
                    <Grid item md={5.5} lg={5.5}>
                        <div className="app-page-form__right">
                            <div>
                                <Scrollbar style={{ height: "calc(100vh - 160px)" }}>
                                    <div className="app-page-form__left--form">
                                        {formdata ? <CustomisedForm form={formdata} /> : <SpinnerCircular />}
                                    </div>
                                </Scrollbar>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
                {/* </Container> */}
            </div>
                
        </>
    )
}

export default Forms
